import React, { useState, useEffect, useCallback } from "react";

import DashboardLayout from "../../dashboardDefaultLayout/DashboardLayout";
import SavestTitle from "./savestTitle";
import SavestCard from "../Savest/SavestCard";
// import SavestTransaction from "./SavestPay/SavestTransaction";
import Transaction from "../Savest/Transaction";
import "./savest.css";
import { $api } from "../../../../../helpers/$api";

const Savest = () => {
  const [balances, setBalances] = useState({ ovest: {}, savest: {} });
  const [transactions, setTransactions] = useState([]);

  const getAsyncData = useCallback(async () => {
    try {
      const [balances, transactions] = await Promise.all([
        $api.user.getBalances(),
        $api.user.getUserSavestTransactions(),
      ]);

      setBalances(balances);
      setTransactions(transactions);
    } catch (error) {
      // ....
    }
  }, [setBalances]);

  useEffect(() => {
    getAsyncData();
  }, [getAsyncData]);

  return (
    <>
      <DashboardLayout>
        <main>
          <div className="savest">
            <SavestTitle />
            <SavestCard savest={balances.savest} />
            <Transaction balances={balances} transactions={transactions} />
            {/* <SavestTransaction transactions={transactions} /> */}
          </div>
        </main>
      </DashboardLayout>
    </>
  );
};

export default Savest;
